import { FacilitiesCarousel } from "./FacilitiesCarousel";
import { FacilitiesList } from "./FacilitiesList";
import { FacilitiesMap } from "./FacilitiesMap";

type FacilitiesCompound = {
  List: typeof FacilitiesList;
  Carousel: typeof FacilitiesCarousel;
  Map: typeof FacilitiesMap;
};

/** The facilities tab's parts. Each renders nothing on other tabs. */
export const Facilities: FacilitiesCompound = {
  List: FacilitiesList,
  Carousel: FacilitiesCarousel,
  Map: FacilitiesMap,
};
